import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

export const UnsavedChangesContent = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: ${owcTheme['one-spacer-px-32']};
`;
